import styled from 'styled-components';

type ContainerProps = {
  colors: { primary: string; secondary: string };
};

export const Container = styled.div<ContainerProps>`
  position: relative;
  width: 100%;
  max-width: 288px;
  min-height: 272px;
  border-radius: 8px;
  background: ${props =>
    props.colors
      ? `linear-gradient(98.57deg,${props.colors.primary} 0%,${props.colors.secondary} 100%)`
      : 'linear-gradient(98.57deg,#007079 0%,#35B8C4 100%)'};
  display: flex;
  flex-direction: row;
  overflow: hidden;
`;

export const Image = styled.img`
  position: absolute;
  bottom: 0;
  right: 32px;
  width: 224px;
  height: auto;
`;
